import { MutationTree } from 'vuex'
import { SavedFiltersState } from './state'
import { ResSavedFilter } from '@/models/users'

export enum SavedFiltersMutationTypes {
  LoadSuccess = '[SavedFilters Mutation] Load Success',
  LastFilter = '[SavedFilters Mutation] Last Filter Load Success'
}

export type SavedFiltersLoadSuccessMutationPayload = {
  data: ResSavedFilter[]
}

export type SavedFiltersLastFilterMutationPayload = {
  data: ResSavedFilter
}

export const mutations: MutationTree<SavedFiltersState> = {
  [SavedFiltersMutationTypes.LoadSuccess](
    state,
    payload: SavedFiltersLoadSuccessMutationPayload,
  ) {
    state.filters = payload.data
  },

  [SavedFiltersMutationTypes.LastFilter](
    state,
    payload: SavedFiltersLastFilterMutationPayload,
  ) {
    state.newFilter = payload.data
  },
}
